import { useState, useEffect } from 'react';
import { Tag, Input, TreeSelect } from 'antd';
import { RightOutlined, UpOutlined, SearchOutlined } from '@ant-design/icons';
import TreeSelectWrapper from 'components/Treewrapper/Treewrapper';

function EbzProductsFilter(productProps) {
  const { data, value, onChange } = productProps;
  const [selectedValues, setSelectedValues] = useState([]);
  const [option, setOption] = useState([]);
  const [filteredOption, setFilteredOption] = useState(null);
  const [open, setOpen] = useState(false);
  const [allIds, setAllIds] = useState([]);

  useEffect(() => {
    if (data?.length) {
      const dataOptions = data.map((name) => {
        return {
          title: `${name.label}`,
          value: name.value
        };
      });

      setOption(dataOptions);
      setAllIds(dataOptions);
    }
  }, [data]);

  const tagRender = (props) => {
    // eslint-disable-next-line react/prop-types
    const { label, closable, onClose } = props;

    return (
      <Tag
        color="#FFFFFF"
        closable={closable}
        onClose={onClose}
        style={{
          color: '#091B49',
          border: '1px solid #091B49',
          cursor: 'default'
        }}
      >
        {label}
      </Tag>
    );
  };

  const handleSearch = (e) => {
    const searchData = e.target.value?.toLowerCase();

    if (searchData && searchData?.length) {
      const hasSearchTerm = (searchTerm) => searchTerm?.toLowerCase().indexOf(searchData) !== -1;
      const filterData = (arr) => arr?.filter((arrayValue) => hasSearchTerm(arrayValue?.title));
      const filteredData = filterData(option).map((arrayValue) => {
        return {
          ...arrayValue,
          children: filterData(arrayValue.children)
        };
      });
      setFilteredOption(filteredData);
    } else {
      setFilteredOption(option);
    }
  };

  const handleDropdownMenu = (menu) => {
    return (
      <>
        <div style={{ padding: '10px 10px' }}>
          <Input
            prefix={<SearchOutlined />}
            placeholder="Please Search Product"
            onChange={handleSearch}
            style={{
              width: '100%'
            }}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          />
        </div>
        {menu}
      </>
    );
  };

  const handleSelection = () => {
    const dataSelectedValues =
      selectedValues?.length > 0 ? [] : allIds.map((products) => products.value);
    onChange(dataSelectedValues);
    setSelectedValues(selectedValues?.length > 0 ? [] : allIds);
  };

  return (
    <TreeSelectWrapper
      placeholder="Choose Product"
      treeCheckable
      showCheckedStrategy={TreeSelect.SHOW_CHILD}
      dropdownStyle={{ maxHeight: '300px' }}
      onChange={(ids) => {
        const filterProduts = ids.map((products) => products.value);
        onChange(filterProduts);
        setSelectedValues(ids);
      }}
      value={value || selectedValues}
      labelInValue
      tagRender={tagRender}
      open={open}
      onDropdownVisibleChange={(visible) => setOpen(visible)}
      suffixIcon={
        <Tag
          style={{
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            display: 'contents'
          }}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => setOpen(!open)}
        >
          {open ? <UpOutlined /> : <RightOutlined />}
        </Tag>
      }
      showArrow
      dropdownRender={(menu) => handleDropdownMenu(menu)}
      treeData={[
        {
          title: (
            <span
              role="presentation"
              onClick={() => {
                handleSelection();
              }}
              style={{
                display: 'inline-block',
                color: 'var(--color-primary)',
                cursor: 'pointer'
              }}
            >
              {selectedValues.length > 0 ? 'Unselect all' : 'Select all'}
            </span>
          ),
          value: 'NA',
          disableCheckbox: true,
          disabled: true
        },
        ...(filteredOption === null ? option : filteredOption)
      ]}
    />
  );
}

export default EbzProductsFilter;
